import { useState } from 'react';
import './TextArea.scss';
import PropTypes from "prop-types";

const TextArea = ({
                      onChange,
                      onSubmit,
                      value,
                      name,
                      onValidate,
                      id,
                      placeholder,
                      label,
                      onClose,
                      cancelText,
                      confirmText,
                      className,
                  }) => {
    const [focused, setFocused] = useState(false);
    const [isValid, setIsValid] = useState(true);

    const handleTextChange = ({target: {value, name}}) => onChange(value, name);
    const handleOnSubmit = () => onSubmit(value);
    const toggleFocused = () => {
        setFocused(!focused);
    }
    const handleBlur = () => {
        if (onValidate) {
            const valid = onValidate(name, value);
            if (!valid) {
                setIsValid(false);
            } else if (valid && !isValid) {
                setIsValid(true);
            }
        }
        toggleFocused();
    }

    return (
        <div>
            {label && (
                <label
                    className={`text-area-label ${!isValid ? 'text-area-label--invalid' : ''}`}
                    htmlFor={id}>
                    {label}
                </label>
            )}
            <div className={`text-area ${focused ? 'text-area--focused ' : ''}${className}`}>
          <textarea
              id={id}
              name={name}
              placeholder={placeholder}
              onBlur={handleBlur}
              onFocus={toggleFocused}
              onChange={handleTextChange}
              value={value}
          />
                <div className="buttons">
                    {cancelText && (
                        <button
                            className="text-area-btn text-area-btn--grey"
                            onClick={onClose}
                            type="button">
                            {cancelText}
                        </button>
                    )}
                    {confirmText && (
                        <button className="text-area-btn text-area-btn--submit"
                                onClick={handleOnSubmit}
                                type="button">
                            {confirmText}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}

TextArea.propTypes = {
    onChange: PropTypes.func.isRequired
}

export default TextArea;
